// extracted by mini-css-extract-plugin
export default {"customStep":"TransactionStyles_customStep__a6sho","customSlider":"TransactionStyles_customSlider__8KqnV"};